import Swiper from 'swiper';
'use strict';

const home = {
	initKeysSlider: function() {
		const keysSwiper = new Swiper('.hpKeys__list', {
			spaceBetween: 12,
			slidesPerView: 'auto',
			centeredSlides: false,
			centerInsufficientSlides: true,
			breakpoints: {
				992: {
					slidesPerView: 5,
				}
			}
		});
	},
}

window.addEventListener('DOMContentLoaded', function() {
	if(body.classList.contains('home')) {
		home.initKeysSlider();
	}
});